interface IconProps {
  name: string
  size?: number
  className?: string
}

// Simple ASCII-style icons
const icons: Record<string, string> = {
  info: `
╔═══╗
║ i ║
╚═══╝`,
  cube: `
 ┌──┐
┌┘  └┐
└────┘`,
  terminal: `
┌────┐
│>_  │
└────┘`,
  folder: `
┌──┬─┐
│    │
└────┘`,
  calculator: `
┌────┐
│1234│
│+-*/│
└────┘`,
  'file-text': `
┌───┐
│───│
│───│
└───┘`,
  mail: `
┌────┐
│\\  /│
│ \\/ │
└────┘`,
  bomb: `
  *
 ╱█╲
 ███
  ▀`,
  globe: `
 ╭───╮
╭┤─┬─├╮
│├─┼─┤│
 ╰─┴─╯`,
  wagon: `
 ┌───┐
┌┤ ░░├┐
└○───○┘`,
  rocket: `
  ▲
 ╱█╲
 │█│
╱ ▼ ╲`,
  window: `
┌────┐
│    │
└────┘`,
  gear: `
 ╔═╗
═╣●╠═
 ╚═╝`,
  robot: `
╔═══╗
║●●║
╚╦╦╦╝
 ███`,
  sword: `
   ╱
  ╱
 ╱
┼`,
  cards: `
♠ ♥
♦ ♣`,
  chess: `
♔ ♚
♙ ♟`,
  dragon: `
 /\\
<◎>
 \\/`,
  close: '×',
  minimize: '─',
  maximize: '□',
  restore: '❐',
}

export function Icon({ name, size = 24, className = '' }: IconProps) {
  const icon = icons[name] || icons.window

  // For small icons (like window controls), use simpler characters
  if (size <= 16) {
    const simpleIcons: Record<string, string> = {
      close: '×',
      minimize: '─',
      maximize: '□',
      restore: '❐',
    }
    return (
      <span
        className={`icon icon--simple ${className}`}
        style={{ fontSize: `${size}px`, lineHeight: 1 }}
        aria-hidden="true"
      >
        {simpleIcons[name] || '■'}
      </span>
    )
  }

  return (
    <pre
      className={`icon ${className}`}
      style={{
        fontSize: `${Math.max(6, size / 5)}px`,
        lineHeight: 1,
        margin: 0,
        color: 'var(--crt-fg)',
      }}
      aria-hidden="true"
    >
      {icon}
    </pre>
  )
}
